/* eslint-disable max-len */
// Copyright (c) 2016 Deere & Company

import BusyCounter, { getDefaultState as getBusyCounterDefaultState } from '../../dealer-search/state/busy-counter';
import DealerSearchModal, { getDefaultState as getDealerSearchModalDefaultState } from './dealer-search-modal';
import NewTransfer, { getDefaultState as getNewTransfersDefaultState } from './new-transfer';
import NewTransferStatusChangeModal, { getDefaultState as getNewTransferStatusChangeModalDefaultState } from './new-transfer-status-change-modal';
import Product, { getDefaultState as getProductDefaultState } from '../../shared/state/product';
import t from 'tcomb';

const State = t.struct({
    accountLookup: t.String,
    busyCounter: BusyCounter,
    dealerSearchModal: DealerSearchModal,
    isAmountOfUseModalOpen: t.Boolean,
    newTransfer: NewTransfer,
    newTransferStatusChangeModal: NewTransferStatusChangeModal,
    product: Product,
}, {
    name: 'State',
    strict: true,
});

export const getDefaultState = () => new State({
    accountLookup: '',
    busyCounter: getBusyCounterDefaultState(),
    dealerSearchModal: getDealerSearchModalDefaultState(),
    isAmountOfUseModalOpen: false,
    newTransfer: getNewTransfersDefaultState(),
    newTransferStatusChangeModal: getNewTransferStatusChangeModalDefaultState(),
    product: getProductDefaultState(),
});

export default State;
